import Vue from 'vue';
import App from './App.vue';
import 'modern-normalize';

Vue.config.productionTip = false;

Vue.mixin({
  data: () => ({
    isInView: false,
  }),
  methods: {
    inView(el) {
      const bbox = el.getBoundingClientRect();
      return bbox.top < window.innerHeight;
    },
    scrollHandler() {
      if (this.inView(this.$el)) this.isInView = true;
    },
  },
  mounted() {
    this.scrollHandler();
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
});

new Vue({
  render: (h) => h(App),
}).$mount('#app');
